import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { CustomerPaymentsTab, PaymentsTabActiveSegment } from '@mews-commander/modules/src/modules/payment';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const { accountId } = Route.useParams();
    const { activeSegment } = Route.useSearch();

    return (
        <CustomerPaymentsTab accountId={accountId} activeSegment={activeSegment ?? PaymentsTabActiveSegment.Overview} />
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Payment/Index/$accountId')({
    component: Component,
    validateSearch: z.object({
        activeSegment: z.nativeEnum(PaymentsTabActiveSegment).optional(),
        EnterpriseId: z.string().uuid().optional(),
    }),
    staticData: {
        routeName: RouteName.PaymentIndex,
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.TakePayment),
    },
});
